function Type(d,p,e){const t={description:d,__runtimeType:true};if(typeof p==='function'){t.check=p;t.default=e??null}else{const ex=e??p;t.default=ex;t.check=v=>{if(ex===null)return true;return typeof v===typeof ex}}return t};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {Type};
/* tjs <- dom.ts */

import { cloneWithBindings } from './metadata'

import { ContentType, ValueElement } from './xin-types'

/* line 4 */
export function dispatch(target,type) {
    const event = new Event(type);
    target.dispatchEvent(event);
}
dispatch.__tjs = {
  "params": {
    "target": {
      "type": {
        "kind": "object",
        "shape": {}
      },
      "required": true,
      "default": null
    },
    "type": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "unsafe": true,
  "source": "dom.ts:8"
}

/* line 9 */
function valueType(element) {
    if (element instanceof HTMLInputElement) {
        return element.type;
    }
    else if (element instanceof HTMLSelectElement &&
        element.hasAttribute('multiple')) {
        return 'multi-select';
    }
    else {
        return 'other';
    }
}
valueType.__tjs = {
  "params": {
    "element": {
      "type": {
        "kind": "object",
        "shape": {}
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "dom.ts:9"
}

/* line 22 */
export function setValue(element, newValue) {
    switch (valueType(element)) {
        case 'radio':
            element.checked =
                element.value === newValue;
            break;
        case 'checkbox':
            element.checked = !!newValue;
            break;
        case 'date':
            element.valueAsDate = new Date(newValue);
            break;
        case 'multi-select':
            for (const option of Array.from(element.querySelectorAll('option'))) {
                option.selected = newValue[option.value];
            }
            break;
        default:
            element.value = newValue;
    }
}
setValue.__tjs = {
  "params": {
    "element": {
      "type": {
        "kind": "object",
        "shape": {}
      },
      "required": true,
      "default": null
    },
    "newValue": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "unsafe": true,
  "source": "dom.ts:28"
}

const PickMap = Type('PickMap')

/* line 49 */
/* TODO: TS types degraded — element: ValueElement */
export function getValue(element) {
    switch (valueType(element)) {
        case 'radio': {
            const radio = element.parentElement?.querySelector(`[name="${element.name}"]:checked`);
            return radio != null ? radio.value : null;
        }
        case 'checkbox':
            return element.checked;
        case 'date':
            return element.valueAsDate?.toISOString();
        case 'multi-select':
            return Array.from(element.querySelectorAll('option')).reduce((map, option) => {
                map[option.value] = option.selected;
                return map;
            }, {});
        default:
            return element.value;
    }
}
getValue.__tjs = {
  "params": {
    "element": {
      "type": {
        "kind": "any"
      },
      "required": true
    }
  },
  "unsafe": true,
  "source": "dom.ts:54"
}

const { ResizeObserver } = globalThis;

export const resizeObserver = ResizeObserver != null
    ? new ResizeObserver((entries) => {
        for (const entry of entries) {
            const element = entry.target;
            dispatch(element, 'resize');
        }
    })
    : {
        observe() { },
        unobserve() { },
    };

/* line 88 */
/* TODO: TS types degraded — content: ContentType | null | undefined */
export function appendContentToElement(elt, content, cloneElements = true) {
    if (elt != null && content != null) {
        if (typeof content === 'string') {
            elt.textContent = content;
        }
        else if (Array.isArray(content)) {
            content.forEach((node) => {
                elt.append(node instanceof Node && cloneElements ? cloneWithBindings(node) : node);
            });
        }
        else if (content instanceof Node) {
            elt.append(cloneElements ? cloneWithBindings(content) : content);
        }
        else {
            throw new Error('expect text content or document node');
        }
    }
}
appendContentToElement.__tjs = {
  "params": {
    "elt": {
      "type": {
        "kind": "union",
        "members": [
          {
            "kind": "object",
            "nullable": true,
            "shape": {}
          },
          {
            "kind": "undefined"
          }
        ]
      },
      "required": true,
      "default": null
    },
    "content": {
      "type": {
        "kind": "any"
      },
      "required": false
    },
    "cloneElements": {
      "type": {
        "kind": "boolean"
      },
      "required": false,
      "default": true
    }
  },
  "unsafe": true,
  "source": "dom.ts:90"
}